import { LoadScript } from "@react-google-maps/api";
import type { ReactNode } from "react";
import MultiAwaitLock from "@/shared/MultiAwaitLock.ts";
import { generalSetting0 } from "@/data/PosSettingsSignal.ts";

const GOOGLE_MAPS_API_KEY = "AIzaSyAV33wT_iRWRzqCASe04YrGwUN2AbEdJaw";

interface GoogleMapsProviderProps {
  children: ReactNode;
}

export const mapScriptLock = new MultiAwaitLock(true)
let isLoadedScript = false

const GoogleMapsProvider = ({ children }: GoogleMapsProviderProps) => {
  return isLoadedScript || !generalSetting0()?.enableDeliverySetting ? (
    children
  ) : (
    <LoadScript
      googleMapsApiKey={GOOGLE_MAPS_API_KEY}
      onLoad={() => {
        isLoadedScript = true;
        console.log("Google Maps script loaded!");
        mapScriptLock.release().then(() => console.log("mapScriptLock release"));
      }}
    >
      {children}
    </LoadScript>
  );
};

export default GoogleMapsProvider;

